module.exports = __webpack_public_path__ + "static/media/order_complete_green.df660b18.png";